/* Colette Brow - tema bozza */

/* I testi visibili arrivano dal Liquid (window.CB_T, vedi layout/theme.liquid):
   cosi' seguono la lingua del negozio. Se per qualsiasi motivo non ci sono,
   si ricade sull'italiano e niente si rompe. */
function cbT(chiave, ripiego, valore) {
  var t = (window.CB_T && window.CB_T[chiave]) || ripiego;
  return (valore === undefined) ? t : t.replace('@', valore);
}

function cbToggleNav() {
  var m = document.getElementById('cbMobnav');
  if (!m) return;
  var open = m.classList.toggle('open');
  var b = document.querySelector('.burger');
  if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
}

/* galleria */
function cbPick(el, src) {
  var main = document.getElementById('cbMain');
  if (main) {
    /* ðŸ”´ Se l'immagine ha un "srcset", il browser IGNORA "src" e continua a
       mostrare la foto di prima: cambiando solo src si aggiorna un attributo
       che nessuno vede, e le miniature sembrano non funzionare.
       Va riscritto anche srcset. Gli URL di Shopify hanno "&width=NNN", quindi
       si ricostruiscono le misure da li'; se il parametro non c'e' si svuota
       srcset e comanda src. */
    if (main.srcset) {
      if (/[?&]width=\d+/.test(src)) {
        main.srcset = [400, 600, 800, 1100].map(function (w) {
          return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w';
        }).join(', ');
      } else {
        main.srcset = '';
      }
    }
    main.src = src;
    var grande = el.getAttribute('data-grande');
    if (grande) main.setAttribute('data-grande', grande);
  }
  var all = el.parentNode.querySelectorAll('img');
  Array.prototype.forEach.call(all, function (i) { i.classList.remove('on'); });
  el.classList.add('on');
  /* i puntini sotto la foto devono seguire QUALUNQUE cambio di immagine:
     miniatura, freccia, scorrimento col dito o scelta del colore. */
  if (window.cbGalSync) window.cbGalSync();
}

/* =========================================================================
   LA FOTO GRANDE SI FA VEDERE
   08/09. Chi sceglie una tonalita' sta guardando i riquadri dei colori, che su
   telefono stanno sotto la foto: la galleria cambiava immagine fuori campo e
   il cliente non si accorgeva di niente. Ora la pagina risale fino alla foto e
   la foto fa un breve bagliore, cosi' il cambio si vede.
   ========================================================================= */
function cbMostraFoto() {
  var cornice = document.querySelector('.gal .main');
  if (!cornice) return;
  var hdr = document.querySelector('.hdr');
  var margine = (hdr ? hdr.offsetHeight : 0) + 12;
  var r = cornice.getBoundingClientRect();
  /* si muove solo se serve: se la foto e' gia' tutta a schermo si sta fermi */
  if (r.top < margine || r.bottom > window.innerHeight) {
    var y = window.pageYOffset + r.top - margine;
    if (y < 0) y = 0;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, y); }
  }
  cornice.classList.remove('gal-lampo');
  void cornice.offsetWidth; /* riavvia l'animazione anche a colori consecutivi */
  cornice.classList.add('gal-lampo');
  setTimeout(function () { cornice.classList.remove('gal-lampo'); }, 900);
}

/* =========================================================================
   LA GALLERIA SEGUE IL COLORE SCELTO
   05/09. Dalle registrazioni Clarity: la gente clicca "Marrone scuro", la foto
   grande resta quella di prima e se ne va senza comprare, perche' non ha mai
   visto la tonalita' che stava scegliendo. Tutte e tre le varianti puntavano
   alla stessa identica immagine e la galleria non sapeva nemmeno cosa fosse
   una variante.
   Due strade, in ordine: (1) la foto collegata alla variante in Shopify;
   (2) se non c'e', una foto della galleria il cui testo alternativo contiene
   il nome del colore. La (2) e' un ripiego vero, non un trucco: serve finche'
   le foto non sono collegate, e continua a funzionare se un domani se ne
   caricano altre senza collegarle.
   Se non si trova niente non succede nulla: la galleria resta dov'e'.
   ========================================================================= */
function cbGalleriaVariante(idVariante, titoloColore) {
  var thumbs = document.querySelectorAll('.thumbs img');
  if (!thumbs.length) return;

  var idFoto = 0;
  var el = document.getElementById('cbVarMedia');
  if (el) {
    try {
      var mappa = JSON.parse(el.textContent);
      idFoto = mappa[idVariante] || mappa[String(idVariante)] || 0;
    } catch (e) { /* JSON rotto: si passa al ripiego */ }
  }

  var scelto = null;
  if (idFoto) {
    Array.prototype.forEach.call(thumbs, function (t) {
      if (!scelto && String(t.getAttribute('data-media')) === String(idFoto)) scelto = t;
    });
  }
  if (!scelto && titoloColore) {
    var cerca = titoloColore.trim().toLowerCase();
    Array.prototype.forEach.call(thumbs, function (t) {
      var alt = (t.getAttribute('data-alt') || '').toLowerCase();
      if (!scelto && alt && alt.indexOf(cerca) > -1) scelto = t;
    });
  }

  /* gia' quella mostrata: non si tocca niente, altrimenti la foto "lampeggia" */
  if (!scelto || scelto.classList.contains('on')) return;
  var src = scelto.getAttribute('data-src');
  if (src) cbPick(scelto, src);
}

/* quantita */
function cbQtyMax() {
  var i = document.getElementById('cbQty');
  if (!i) return 99;
  var a = i.getAttribute('max');
  if (a === null || a === '') return 99;
  var m = parseInt(a, 10);
  if (isNaN(m)) return 99;
  /* max="0" (variante esaurita) non deve diventare 99: si resta a 1 */
  return m < 1 ? 1 : m;
}
/* NB: il pulsante +/- NON puo' chiamare una funzione globale con un inline onclick:
   dentro un handler inline l'identificatore viene risolto anche sul <form>, e il form
   ha un controllo con id "cbQty" -> "cbQty" diventa l'<input>, non la funzione.
   Per questo i due pulsanti si agganciano con addEventListener piu' sotto. */
function cbQtyStep(d) {
  var i = document.getElementById('cbQty');
  if (!i) return;
  var n = parseInt(i.value, 10);
  if (isNaN(n)) n = 1;
  n = Math.max(1, Math.min(cbQtyMax(), n + d));
  i.value = n;
  cbSyncBundle(n);
}
/* la quantita si puo anche digitare: va normalizzata o il form parte con un valore non valido */
function cbQtyTyped() {
  var i = document.getElementById('cbQty');
  if (!i) return;
  var n = parseInt(i.value, 10);
  if (isNaN(n) || n < 1) n = 1;
  n = Math.min(cbQtyMax(), n);
  i.value = n;
  cbSyncBundle(n);
}

/* scaglioni: impostano la quantita, lo sconto lo applica Shopify in automatico */
function cbBundle(el) {
  var q = parseInt(el.getAttribute('data-qty'), 10) || 1;
  var i = document.getElementById('cbQty');
  if (i) {
    var max = cbQtyMax();
    if (q > max) q = max;      /* mai oltre la giacenza della variante scelta */
    i.value = q;
  }
  cbSyncBundle(q);
}
function cbSyncBundle(q) {
  var all = document.querySelectorAll('.bnd');
  var scelto = null;
  Array.prototype.forEach.call(all, function (b) {
    var on = parseInt(b.getAttribute('data-qty'), 10) === q;
    b.classList.toggle('on', on);
    b.setAttribute('aria-checked', on ? 'true' : 'false');
    if (on) scelto = b;
  });
  cbTotale(scelto, q);
  /* il numero di righe del mix segue sempre la quantita' scelta */
  cbMixRender(q);
}

/* Quantita' che non corrisponde a nessun pacchetto (5, 6, 7... si arriva col
   pulsante +). Verificato sul carrello vero il 05/09: lo sconto automatico e'
   a scaglioni fissi - 9,90 da 2 pezzi, 19,80 da 3, 29,70 da 4 in su - quindi
   il totale si calcola prendendo lo sconto dello scaglione piu' alto che ci
   sta dentro. Controprova con il carrello: 5 pz 119,80 - 6 pz 149,70 -
   8 pz 209,50, identici al calcolo. */
function cbFuoriScaglione(q) {
  var uno = document.querySelector('.bnd-uno');
  if (!uno) return null;
  var unita = cbCent(uno.getAttribute('data-total'));
  if (unita === null || q < 1) return null;

  var sconto = 0;
  Array.prototype.forEach.call(document.querySelectorAll('.bnd'), function (b) {
    if (b === uno) return;                       /* il "1 pezzo" barra il prezzo pieno, non e' uno scaglione */
    var bq = parseInt(b.getAttribute('data-qty'), 10);
    var bt = cbCent(b.getAttribute('data-total'));
    var bf = cbCent(b.getAttribute('data-full'));
    if (!bq || bt === null || bf === null || bq > q) return;
    var s = bf - bt;
    if (s > sconto) sconto = s;
  });

  var pieno = unita * q;
  return { total: cbMoney(pieno - sconto), full: sconto > 0 ? cbMoney(pieno) : '' };
}

/* Da centesimi alla stessa forma usata da Shopify sulla pagina ("EUR29,90",
   "29,90 EUR", "$1,234.56"...): il modello lo prendo dal riquadro "1 pezzo",
   cosi' non serve sapere qui come e' impostata la valuta del negozio. */
function cbMoney(c) {
  var uno = document.querySelector('.bnd-uno');
  var esempio = uno ? (uno.getAttribute('data-total') || '') : '';
  var m = esempio.match(/^([^0-9]*)[0-9.,]+([^0-9]*)$/);
  var pre = m ? m[1] : '', suf = m ? m[2] : '';
  var dec = esempio.lastIndexOf(',') > esempio.lastIndexOf('.') ? ',' : '.';
  var mil = dec === ',' ? '.' : ',';
  var i = Math.floor(c / 100), d = c % 100;
  return pre + String(i).replace(/\B(?=([0-9]{3})+(?![0-9]))/g, mil) + dec + (d < 10 ? '0' + d : String(d)) + suf;
}
/* Il totale della scelta finisce dentro il pulsante di acquisto.
   Prima si toccava "Aggiungi al carrello" senza sapere quanto si stava per
   spendere e il conto compariva solo nel carrello. */
function cbTotale(scelto, q) {
  var t = scelto ? (scelto.getAttribute('data-total') || '') : '';
  var f = scelto ? (scelto.getAttribute('data-full') || '') : '';
  if (!scelto) {
    /* 05/09 BUG RISOLTO: con 5 o piu' pezzi non c'e' nessun riquadro acceso.
       Prima il prezzo grande restava fermo sul totale del pacchetto scelto
       PRIMA (7 pezzi mostravano 69,90) e il pulsante perdeva del tutto la
       cifra: "AGGIUNGI AL CARRELLO" senza prezzo. */
    var calc = cbFuoriScaglione(q);
    if (calc) { t = calc.total; f = calc.full; }
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-add-total]'), function (e) {
    e.textContent = t;
    e.style.display = t ? '' : 'none';
  });

  /* 05/09 BUG RISOLTO: scegliendo il pacchetto da 2/3/4 il prezzo grande in
     cima restava inchiodato al prezzo di UN pezzo. Il totale finiva solo
     dentro al pulsante, quindi in cima si leggeva 29,90 e nel pulsante 49,90:
     due numeri diversi nella stessa schermata. Ora il prezzo grande, il
     barrato e la percentuale seguono il pacchetto selezionato. */
  var p = document.getElementById('cbPrice');
  if (p && t) p.textContent = t;

  var c = document.getElementById('cbCompare');
  var b = document.getElementById('cbBadge');
  var ct = cbCent(t), cf = cbCent(f);
  var mostra = !!(f && ct !== null && cf !== null && cf > ct);
  if (c) { c.textContent = mostra ? f : ''; c.hidden = !mostra; }
  if (b) {
    if (mostra) { b.textContent = '-' + Math.round((cf - ct) * 100 / cf) + '%'; }
    b.hidden = !mostra;
  }
}
/* Da "29,90 EUR" / "€29,90" / "1.234,56" ai centesimi.
   Serve solo per calcolare la percentuale del badge: i prezzi dei pacchetti
   sono testo scritto a mano nel personalizzatore, non numeri.
   Restituisce null se la stringa non e' un prezzo: in quel caso il badge
   viene nascosto invece di stampare "-NaN%". */
function cbCent(s) {
  if (!s) return null;
  var n = String(s).replace(/[^0-9.,]/g, '');
  if (!n) return null;
  var ic = n.lastIndexOf(','), ip = n.lastIndexOf('.');
  var sep = ic > ip ? ic : ip;
  var dec = '';
  var coda = n.length - sep - 1;
  /* separatore decimale = l'ultimo . o , seguito da 1 o 2 cifre.
     Con 3 cifre e' il punto delle migliaia ("1.234"), non i decimali. */
  if (sep > -1 && coda > 0 && coda <= 2) {
    dec = n.slice(sep + 1);
    n = n.slice(0, sep);
  }
  n = n.replace(/[.,]/g, '');
  if (!/^[0-9]+$/.test(n)) return null;
  while (dec.length < 2) dec += '0';
  return parseInt(n, 10) * 100 + parseInt(dec, 10);
}


/* =========================================================================
   SCELTA DEL COLORE PEZZO PER PEZZO (mix)
   Con i pacchetti da 2/3/4 la pagina aggiungeva N volte LA STESSA variante:
   chi voleva due tonalita' diverse doveva fare due giri di carrello e nessuno
   lo capiva. Da qui in poi ogni pezzo ha la sua riga con il proprio colore.
   Quando il mix e' visibile il selettore singolo in alto sparisce: due comandi
   che comandano la stessa cosa erano proprio l'origine della confusione.
   ========================================================================= */
var cbMixSel = [];        /* un id variante per ogni pezzo */
var cbMixLimite = 12;     /* oltre non ha senso disegnare una riga per pezzo */
var cbVarCache = null;

function cbVars() {
  if (cbVarCache) return cbVarCache;
  var s = document.getElementById('cbVarData');
  cbVarCache = [];
  if (s) { try { cbVarCache = JSON.parse(s.textContent) || []; } catch (e) { cbVarCache = []; } }
  return cbVarCache;
}
function cbVarById(id) {
  var v = cbVars();
  for (var i = 0; i < v.length; i++) if (String(v[i].id) === String(id)) return v[i];
  return null;
}
/* la variante da cui parte il mix: quella scelta in alto, se comprabile */
function cbVarBase() {
  var sel = document.getElementById('cbVariant');
  var v = sel ? cbVarById(sel.value) : null;
  if (v && v.a) return v;
  var all = cbVars();
  for (var i = 0; i < all.length; i++) if (all[i].a) return all[i];
  return all[0] || null;
}
function cbMixAttivo() {
  var box = document.getElementById('cbMix');
  return !!(box && !box.hidden && cbMixSel.length > 1);
}
function cbMixMisto() {
  for (var i = 1; i < cbMixSel.length; i++) if (String(cbMixSel[i]) !== String(cbMixSel[0])) return true;
  return false;
}
function cbMixConta(id) {
  var n = 0;
  for (var i = 0; i < cbMixSel.length; i++) if (String(cbMixSel[i]) === String(id)) n++;
  return n;
}
function cbMixErrore(testo) {
  var e = document.getElementById('cbMixErr');
  if (!e) return;
  e.textContent = testo || '';
  e.hidden = !testo;
}
/* Il check-out accelerato (Shop Pay / PayPal) sa mandare UNA sola variante:
   a colori misti manderebbe solo il primo e si pagherebbe la cosa sbagliata.
   Quindi con piu' colori si nasconde e resta il pulsante normale. */
function cbExpress(mostra) {
  var e = document.querySelector('.pdp-express');
  if (e) e.style.display = mostra ? '' : 'none';
}

function cbMixRender(q) {
  var box = document.getElementById('cbMix');
  var sw = document.getElementById('cbSwatchWrap');
  if (!box) return;
  var vars = cbVars();
  var comprabili = 0;
  for (var i = 0; i < vars.length; i++) if (vars[i].a) comprabili++;
  /* niente mix con un solo colore comprabile, con un pezzo solo, o con una
     quantita' cosi' alta da rendere assurda una riga per pezzo */
  if (vars.length < 2 || comprabili < 2 || q < 2 || q > cbMixLimite) {
    box.hidden = true;
    if (sw) sw.hidden = false;
    cbMixSel = [];
    cbMixErrore('');
    cbExpress(true);
    return;
  }
  var base = cbVarBase();
  var baseId = base ? base.id : null;
  /* si allunga o si accorcia mantenendo le scelte gia' fatte */
  while (cbMixSel.length < q) cbMixSel.push(baseId);
  if (cbMixSel.length > q) cbMixSel.length = q;
  /* una variante finita nel frattempo non puo' restare selezionata */
  for (var k = 0; k < cbMixSel.length; k++) {
    var vv = cbVarById(cbMixSel[k]);
    if (!vv || !vv.a) cbMixSel[k] = baseId;
  }
  box.hidden = false;
  if (sw) sw.hidden = true;
  cbMixDisegna();
}

function cbMixDisegna() {
  var rows = document.getElementById('cbMixRows');
  if (!rows) return;
  var vars = cbVars(), n, j;
  if (rows.childElementCount !== cbMixSel.length) {
    rows.innerHTML = '';
    for (n = 0; n < cbMixSel.length; n++) {
      var r = document.createElement('div');
      r.className = 'mix-row';
      var l = document.createElement('span');
      l.className = 'mix-lbl';
      l.textContent = cbT('mix_pezzo', 'Pezzo @', n + 1);
      r.appendChild(l);
      var g = document.createElement('div');
      g.className = 'mix-sw';
      for (j = 0; j < vars.length; j++) {
        var v = vars[j];
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mix-b' + (v.a ? '' : ' mix-off');
        b.setAttribute('data-v', v.id);
        b.setAttribute('data-i', n);
        b.textContent = v.a ? v.t : v.t + ' — ' + cbT('esaurito_min', 'esaurito');
        if (!v.a) b.disabled = true;
        g.appendChild(b);
      }
      r.appendChild(g);
      rows.appendChild(r);
    }
  }
  Array.prototype.forEach.call(rows.querySelectorAll('.mix-b'), function (b) {
    var i = parseInt(b.getAttribute('data-i'), 10);
    var on = String(cbMixSel[i]) === b.getAttribute('data-v');
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  cbMixRiepilogo();
  cbMixSync();
}

/* riga di riepilogo: si legge in chiaro cosa sta per finire nel carrello */
function cbMixRiepilogo() {
  var nota = document.getElementById('cbMixNote');
  if (!nota) return;
  var ordine = [], mappa = {}, i;
  for (i = 0; i < cbMixSel.length; i++) {
    var k = String(cbMixSel[i]);
    if (!mappa[k]) { mappa[k] = 0; ordine.push(k); }
    mappa[k]++;
  }
  var pezzi = ordine.map(function (k) {
    var v = cbVarById(k);
    return mappa[k] + ' × ' + (v ? v.t : '');
  });
  nota.textContent = cbT('mix_carrello', 'Nel carrello: @', pezzi.join(', '));
}

/* il <select> nascosto e il fallback senza JavaScript restano coerenti */
function cbMixSync() {
  var sel = document.getElementById('cbVariant');
  if (sel && cbMixSel.length) {
    var id = String(cbMixSel[0]);
    Array.prototype.forEach.call(sel.options, function (o) {
      if (o.value === id) sel.value = id;
    });
  }
  cbExpress(!cbMixMisto());
}

function cbMixScegli(i, id) {
  var v = cbVarById(id);
  if (!v || !v.a) return;
  if (String(cbMixSel[i]) === String(v.id)) return;
  var prima = cbMixSel[i];
  cbMixSel[i] = v.id;
  var tetto = (typeof v.m === 'number' && v.m >= 0) ? v.m : 99;
  if (cbMixConta(v.id) > tetto) {
    cbMixSel[i] = prima;
    cbMixDisegna();
    cbMixErrore(cbT('mix_max', 'Di @ non ci sono abbastanza pezzi.', v.t));
    return;
  }
  cbMixErrore('');
  cbMixDisegna();
}

/* selezione variante dalle opzioni */
function cbOpt(input) {
  var lbl = input.closest('.sw');
  if (lbl) {
    var sibs = lbl.parentNode.querySelectorAll('.sw');
    Array.prototype.forEach.call(sibs, function (s) { s.classList.remove('on'); });
    lbl.classList.add('on');
  }
  var name = document.getElementById('cbOptName');
  if (name) name.textContent = input.value;

  var sel = document.getElementById('cbVariant');
  if (!sel) return;
  var wanted = input.value.trim();
  Array.prototype.forEach.call(sel.options, function (o) {
    if (o.text.trim() === wanted) {
      sel.value = o.value;
      var p = document.getElementById('cbPrice');
      var c = document.getElementById('cbCompare');
      if (p && o.dataset.price) p.textContent = o.dataset.price;
      if (c && o.dataset.compare) c.textContent = o.dataset.compare;
      /* il riquadro "1 pezzo" mostra il prezzo della variante scelta */
      var uno = document.querySelector('.bnd-uno');
      if (uno && o.dataset.price) {
        uno.setAttribute('data-total', o.dataset.price);
        /* senza questo, cambiando colore il barrato del prezzo grande resta
           quello della variante precedente */
        if (o.dataset.compare && cbCent(o.dataset.compare) > cbCent(o.dataset.price)) {
          uno.setAttribute('data-full', o.dataset.compare);
        } else {
          uno.removeAttribute('data-full');
        }
        var uu = uno.querySelector('[data-uno-unit]'); if (uu) uu.textContent = o.dataset.price;
        var ut = uno.querySelector('[data-uno-tot]'); if (ut) ut.textContent = o.dataset.price;
      }
      /* la foto grande segue il colore scelto e si fa vedere */
      cbGalleriaVariante(o.value, o.text);
      cbMostraFoto();
      /* ogni variante ha la sua giacenza: senza questo il + arriva oltre il disponibile */
      var q = document.getElementById('cbQty');
      if (q && o.dataset.max) {
        q.setAttribute('max', o.dataset.max);
        cbQtyTyped();
      }
    }
  });
  /* il totale nel pulsante va riallineato anche quando la giacenza non cambia */
  var qq = document.getElementById('cbQty');
  cbSyncBundle(qq ? (parseInt(qq.value, 10) || 1) : 1);
}

/* carosello recensioni */
var cbI = 0, cbN = 0;
function cbInitCarou() {
  var track = document.getElementById('cbTrack');
  var dots = document.getElementById('cbDots');
  if (!track || !dots) return;
  cbN = track.children.length;
  for (var k = 0; k < cbN; k++) {
    (function (j) {
      var b = document.createElement('button');
      b.setAttribute('aria-label', cbT('recensione_n', 'Recensione @', j + 1));
      if (j === 0) b.className = 'on';
      b.onclick = function () { cbGo(j); };
      dots.appendChild(b);
    })(k);
  }
}
function cbGo(k) {
  var track = document.getElementById('cbTrack');
  var dots = document.getElementById('cbDots');
  if (!track || !cbN) return;
  cbI = (k + cbN) % cbN;
  track.style.transform = 'translateX(' + (-cbI * 100) + '%)';
  Array.prototype.forEach.call(dots.children, function (d, j) {
    d.className = (j === cbI) ? 'on' : '';
  });
}
function cbSlide(d) { cbGo(cbI + d); }

document.addEventListener('DOMContentLoaded', function () {
  cbInitCarou();
  var i = document.getElementById('cbQty');
  if (i) {
    cbSyncBundle(parseInt(i.value, 10) || 1);
    i.addEventListener('change', cbQtyTyped);
    i.addEventListener('blur', cbQtyTyped);
  }
  Array.prototype.forEach.call(document.querySelectorAll('.qty-step'), function (b) {
    b.addEventListener('click', function () {
      cbQtyStep(parseInt(b.getAttribute('data-step'), 10) || 0);
    });
  });

  /* --- riquadri multipack: clic e tastiera ---
     L'onclick era scritto nell'HTML di ogni riquadro; ora e' una delega sola,
     cosi' funziona anche con Invio/Spazio. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('.bnd');
    if (b) cbBundle(b);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target.closest) return;
    var b = e.target.closest('.bnd');
    if (b) { e.preventDefault(); cbBundle(b); }
  });

  /* --- varianti colore: rispondono SEMPRE, anche ritoccando quella gia' scelta ---
     Il riquadro chiamava solo onchange: toccare il colore gia' selezionato non
     generava alcun evento e il tocco risultava perso (clic non recapitabili
     nelle registrazioni). */
  /* --- mix: un colore per ogni pezzo --- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('.mix-b');
    if (!b || b.disabled) return;
    cbMixScegli(parseInt(b.getAttribute('data-i'), 10) || 0, b.getAttribute('data-v'));
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var lbl = e.target.closest('.sw');
    if (!lbl || lbl.classList.contains('sw-off')) return;
    var inp = lbl.querySelector('input[type=radio]');
    if (!inp || inp.disabled) return;
    inp.checked = true;
    cbOpt(inp);
  });
});

/* =========================================================================
   CARRELLO A SCOMPARSA
   Il pannello sta nel layout (sections/cart-drawer.liquid) ed e' quindi presente
   su ogni pagina. Dopo ogni aggiunta o modifica viene ricaricato con la Section
   Rendering API (/?sections=cart-drawer): cosi' prezzi, sconti e limiti di giacenza
   li calcola sempre Liquid, non il JavaScript.
   Se il browser non ha fetch/closest non si aggancia niente: l'icona resta un link
   a /cart e il form prodotto fa il POST normale. Nessuna funzione persa.
   ========================================================================= */
(function () {
  if (!window.fetch || !Element.prototype.closest || !window.FormData) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var occupato = false;
  var apertoDa = null; /* elemento a cui restituire il focus alla chiusura */

  function pannello() { return document.getElementById('cbDrawer'); }

  function badge(n) {
    var ico = document.querySelector('.cart-ico');
    if (!ico) return;
    var b = ico.querySelector('.cnt');
    if (n > 0) {
      if (!b) { b = document.createElement('span'); b.className = 'cnt'; ico.appendChild(b); }
      b.textContent = n;
    } else if (b) {
      b.parentNode.removeChild(b);
    }
    ico.setAttribute('aria-label', cbT('carrello_aria', 'Carrello (@ articoli)', n));
  }

  function apri(origine) {
    var d = pannello();
    if (!d) return;
    apertoDa = origine || document.activeElement;
    document.body.classList.add('cb-cart-open');
    d.setAttribute('aria-hidden', 'false');
    var x = d.querySelector('.cb-dr-x');
    if (x) x.focus();
  }

  function chiudi() {
    var d = pannello();
    document.body.classList.remove('cb-cart-open');
    if (d) d.setAttribute('aria-hidden', 'true');
    if (apertoDa && apertoDa.focus) apertoDa.focus();
    apertoDa = null;
  }

  /* ricarica il pannello dal server e lo rimpiazza in pagina */
  function ricarica() {
    return fetch(ROOT + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nuovo = tmp.querySelector('#cbDrawer');
        var vecchio = pannello();
        if (nuovo && vecchio) {
          /* si sostituisce solo l'<aside>: la classe di apertura sta sul <body>,
             quindi il pannello non si richiude durante l'aggiornamento */
          vecchio.parentNode.replaceChild(nuovo, vecchio);
          nuovo.setAttribute('aria-hidden', document.body.classList.contains('cb-cart-open') ? 'false' : 'true');
          badge(parseInt(nuovo.getAttribute('data-cart-count'), 10) || 0);
        }
      });
  }

  function errore(dentro, msg) {
    var box = dentro ? dentro.querySelector('[data-cart-err]') : null;
    if (!box) box = document.querySelector('[data-cart-err]');
    if (!box) { alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
    box.scrollIntoView({ block: 'nearest' });
  }

  /* cambio quantita di una riga gia' nel carrello */
  function cambia(form, key, qty) {
    if (occupato) return;
    occupato = true;
    form.classList.add('is-busy');
    var nelPannello = !!form.closest('.cb-dr');
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          occupato = false;
          form.classList.remove('is-busy');
          errore(form.parentNode, (res.d && res.d.description) || cbT('err_aggiorna', 'Non è stato possibile aggiornare il carrello.'));
          return;
        }
        if (nelPannello) {
          /* ricarica() sostituisce l'<aside>, quindi di norma la classe sparisce
             con il nodo vecchio. Se pero' il server non restituisce la sezione il
             nodo resta quello di prima: senza questa riga si bloccherebbe con
             pointer-events:none e tutto il carrello diventerebbe non cliccabile. */
          return ricarica().then(function () {
            occupato = false;
            form.classList.remove('is-busy');
          });
        }
        window.location.reload();
      })
      .catch(function () {
        occupato = false;
        form.classList.remove('is-busy');
        errore(form.parentNode, cbT('err_connessione', 'Connessione non riuscita. Riprova.'));
      });
  }

  /* --- API per le altre sezioni ---
     La sezione "Pacchetti" della home deve aggiungere al carrello senza avere
     il modulo della scheda prodotto (#cbForm). Invece di duplicare la fetch e
     il pannello si espone qui il minimo indispensabile: stessa coda "occupato",
     stesso ricaricamento del pannello, stessa apertura del carrello.
     items = [{id: 123, quantity: 2}, ...] */
  window.cbCartAdd = function (items, btn, suErrore) {
    if (occupato) return false;
    occupato = true;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          occupato = false;
          if (suErrore) suErrore((res.d && res.d.description) || cbT('err_aggiungi', 'Non è stato possibile aggiungere il prodotto.'));
          return;
        }
        return ricarica().then(function () { occupato = false; apri(btn); });
      })
      .catch(function () {
        occupato = false;
        if (suErrore) suErrore(cbT('err_connessione', 'Connessione non riuscita. Riprova.'));
      });
    return true;
  };

  /* --- pulsante "Procedi al check-out" ---
     Il POST del modulo /cart si e' rivelato inaffidabile da telefono: nella
     registrazione Clarity del 6/09 (utente 5f1uqd) il tocco parte, l'evento
     submit scatta a 01:46 e 01:48, ma il browser resta fermo sul pannello e
     dopo 25 secondi la persona rinuncia. Le quantita' sono gia' sincronizzate
     sul server a ogni modifica (cart/change.js), quindi il modulo non serve:
     si va al check-out con una navigazione normale, che non puo' fallire.
     Il pulsante resta type=submit name=checkout: senza JavaScript il POST
     classico continua a funzionare. */
  function vaiAlCheckout() { window.location.href = ROOT + 'checkout'; }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('button[name="checkout"]');
    if (!b) return;
    e.preventDefault();

    /* per sicurezza si toglie qualunque stato di blocco rimasto appeso */
    var f = b.closest('[data-cart-form]');
    if (f) f.classList.remove('is-busy');
    b.disabled = false;

    if (!occupato) { vaiAlCheckout(); return; }

    /* c'e' un aggiornamento di quantita' in volo: si aspetta che finisca,
       al massimo 2 secondi, poi si parte comunque */
    var inizio = Date.now();
    (function attendi() {
      if (!occupato || Date.now() - inizio > 2000) { vaiAlCheckout(); return; }
      setTimeout(attendi, 100);
    })();
  }, true);

  /* --- apertura / chiusura --- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var apriEl = e.target.closest('[data-cart-open]');
    if (apriEl) {
      e.preventDefault();
      apri(apriEl);
      /* il pannello in pagina puo' essere vecchio: carrello cambiato in un'altra
         scheda, o pagina ripresa dalla cache del browser. Si apre subito (niente
         attesa) e si aggiorna dal server un attimo dopo. */
      ricarica();
      return;
    }

    var chiudiEl = e.target.closest('[data-cart-close]');
    if (chiudiEl) { e.preventDefault(); chiudi(); return; }

    /* +/- e "Rimuovi", sia nel pannello sia nella pagina /cart */
    var a = e.target.closest('a[data-cart-qty]');
    if (a) {
      var form = a.closest('[data-cart-form]');
      var row = a.closest('.cart-row');
      if (!form || !row) return;
      e.preventDefault();
      cambia(form, row.getAttribute('data-key'), parseInt(a.getAttribute('data-cart-qty'), 10));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('cb-cart-open')) chiudi();
  });

  /* --- quantita digitata a mano --- */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i.hasAttribute || !i.hasAttribute('data-cart-input')) return;
    var form = i.closest('[data-cart-form]');
    var row = i.closest('.cart-row');
    if (!form || !row) return;
    var max = parseInt(i.getAttribute('max'), 10) || 99;
    var n = parseInt(i.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    var attuale = parseInt(i.getAttribute('value'), 10);
    if (n > max) { n = max; errore(form.parentNode, cbT('max_pezzi', 'Disponibilità massima: @ pezzi.', max)); }
    i.value = n;
    /* se il valore corretto e' gia' quello nel carrello non si chiama il server:
       il ricaricamento del pannello cancellerebbe l'avviso appena mostrato */
    if (n === attuale) return;
    cambia(form, row.getAttribute('data-key'), n);
  });

  /* --- aggiunta al carrello dalla scheda prodotto --- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* ATTENZIONE: form.id NON e' la stringa "cbForm". Il form contiene
       <select name="id"> e la ricerca per nome del <form> restituisce quel campo
       al posto dell'attributo. Stesso tranello del vecchio bug su cbQty.
       L'attributo va letto con getAttribute. */
    if (form.getAttribute('id') !== 'cbForm') return;
    e.preventDefault();
    if (occupato) return;
    occupato = true;

    var btn = form.querySelector('button[type=submit]');
    /* si salva l'HTML e non il testo: il pulsante contiene il totale dentro uno
       <span>, ripristinando textContent il totale sparirebbe dopo la prima aggiunta */
    var testo = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = cbT('aggiungo', 'Aggiungo…'); }
    var box = document.getElementById('cbAddErr');
    if (box) box.hidden = true;

    function ripristina() {
      occupato = false;
      if (btn) { btn.disabled = false; btn.innerHTML = testo; }
    }

    /* Con il mix attivo il carrello riceve PIU' righe (una per colore), quindi
       non basta il FormData del modulo: si manda items[] in JSON. Senza mix
       resta esattamente la chiamata di prima. */
    var intestazioni = { 'Accept': 'application/json' };
    var corpo;
    if (typeof cbMixAttivo === 'function' && cbMixAttivo()) {
      var mappa = {}, ordine = [], i;
      for (i = 0; i < cbMixSel.length; i++) {
        var k = String(cbMixSel[i]);
        if (!mappa[k]) { mappa[k] = 0; ordine.push(k); }
        mappa[k]++;
      }
      corpo = JSON.stringify({
        items: ordine.map(function (k) { return { id: parseInt(k, 10), quantity: mappa[k] }; })
      });
      intestazioni['Content-Type'] = 'application/json';
    } else {
      corpo = new FormData(form);
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: intestazioni,
      body: corpo
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          ripristina();
          if (box) {
            box.textContent = (res.d && res.d.description) || cbT('err_aggiungi', 'Non è stato possibile aggiungere il prodotto.');
            box.hidden = false;
          }
          return;
        }
        return ricarica().then(function () { ripristina(); apri(btn); });
      })
      .catch(function () {
        ripristina();
        if (box) { box.textContent = cbT('err_connessione', 'Connessione non riuscita. Riprova.'); box.hidden = false; }
      });
  });
})();

/* =========================================================================
   BARRA "AGGIUNGI AL CARRELLO" SOPRA IL BANNER DEI COOKIE
   Il banner privacy di Shopify e' fissato in fondo allo schermo e su telefono
   e' alto circa 310 px su 812: copriva per intero la barra di acquisto, che e'
   il pulsante piu' a portata di pollice. Chi arrivava per la prima volta - cioe'
   tutti quelli che vengono dai social - la trovava morta finche' non toccava
   Accetta o Rifiuta.
   Qui la barra si alza sopra il banner e torna giu' da sola quando il banner
   sparisce. Se il banner non c'e', non cambia niente.
   ========================================================================= */
(function () {
  /* 03/09: la stessa logica serve anche alla barra della home (.hsticky) */
  var barre = [].slice.call(document.querySelectorAll('.sticky, .hsticky'));
  if (!barre.length) return;

  function altezzaBanner() {
    /* 03/09 BUG RISOLTO: Shopify non genera piu' il contenitore
       .shopify-pc__banner, oggi il banner e' .shopify-pc__banner__dialog.
       Con il vecchio selettore questa funzione restituiva sempre 0 e la
       barra restava sepolta sotto il banner: misurato il 03/09 su 375x812,
       barra 727-812 dentro un banner 500-812, coperta al 100%. */
    var b = document.querySelector('.shopify-pc__banner, .shopify-pc__banner__dialog');
    if (!b) return 0;
    var cs = window.getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return 0;
    var r = b.getBoundingClientRect();
    /* si alza solo se il banner e' davvero appoggiato in fondo e la copre */
    if (r.height < 1) return 0;
    if (r.bottom < window.innerHeight - 4) return 0;
    return Math.round(r.height);
  }

  /* NB: niente requestAnimationFrame qui. Nelle schede che non sono in primo
     piano il browser lo sospende, e la barra resterebbe sotto il banner fino al
     ritorno sulla scheda. Un timer normale funziona anche in secondo piano. */
  var attesa = null;
  function sistema() {
    if (attesa) return;
    attesa = setTimeout(function () {
      attesa = null;
      var h = altezzaBanner();
      for (var i = 0; i < barre.length; i++) {
        barre[i].style.bottom = h ? h + 'px' : '';
      }
    }, 50);
  }

  sistema();
  window.addEventListener('resize', sistema);
  window.addEventListener('orientationchange', sistema);

  /* il banner viene inserito da Shopify dopo il caricamento: si resta in ascolto
     finche' compare, e anche per quando l'utente lo chiude */
  if (window.MutationObserver) {
    new MutationObserver(sistema).observe(document.body, { childList: true, subtree: true });
  }
  /* rete di sicurezza per i browser lenti */
  setTimeout(sistema, 1200);
  setTimeout(sistema, 3500);
})();

/* =========================================================================
   INGRANDIMENTO DELLE FOTO DEL PRODOTTO
   Cliccare sulla foto grande non faceva NIENTE: nessun gestore, nemmeno il
   cursore che cambia. Su un negozio online il primo gesto e' toccare la foto
   per vederla meglio, e restava senza risposta - nelle registrazioni si vedono
   i clic ripetuti a vuoto.
   Ora la foto si apre a schermo intero, con frecce, scorrimento col dito,
   tasti freccia e chiusura con X, sfondo o Esc.
   ========================================================================= */
(function () {
  var lb = document.getElementById('cbLb');
  var lbImg = document.getElementById('cbLbImg');
  var main = document.getElementById('cbMain');
  if (!lb || !lbImg || !main) return;

  var mini = [].slice.call(document.querySelectorAll('.gal .thumbs img'));
  var indice = 0;
  var scorso = false; /* true subito dopo uno scorrimento: il click che segue non chiude */

  function grandeDi(el) {
    return (el && el.getAttribute('data-grande')) || (el && el.src) || '';
  }

  function indiceAttuale() {
    for (var i = 0; i < mini.length; i++) {
      if (mini[i].classList.contains('on')) return i;
    }
    return 0;
  }

  function mostra(i) {
    if (!mini.length) { lbImg.src = grandeDi(main); return; }
    indice = (i + mini.length) % mini.length;
    lbImg.src = grandeDi(mini[indice]);
    lbImg.alt = mini[indice].alt || '';
    var n = document.getElementById('cbLbN');
    if (n) n.textContent = (indice + 1) + ' / ' + mini.length;
  }

  function apri() {
    mostra(indiceAttuale());
    document.body.classList.add('lb-aperta');
    lb.setAttribute('aria-hidden', 'false');
    var x = lb.querySelector('.lb-x');
    if (x) x.focus();
  }

  function chiudi() {
    document.body.classList.remove('lb-aperta');
    lb.setAttribute('aria-hidden', 'true');
    if (main && main.focus) main.focus();
  }

  /* la foto grande e la lente aprono l'ingrandimento */
  main.addEventListener('click', apri);
  main.style.cursor = 'zoom-in';

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-zoom-apri]')) { e.preventDefault(); apri(); return; }
    if (e.target.closest('[data-zoom-chiudi]')) { e.preventDefault(); chiudi(); return; }
    var p = e.target.closest('[data-zoom-passo]');
    if (p) { e.preventDefault(); mostra(indice + (parseInt(p.getAttribute('data-zoom-passo'), 10) || 0)); return; }
    /* Sul telefono la foto occupa quasi tutto lo schermo: chi vuole chiudere
       tocca la foto, non il bordo scuro, e prima non succedeva niente.
       Ora chiude qualunque tocco che non sia una freccia o la X; uno scorrimento
       laterale non conta (vedi il flag "scorso"). */
    if (document.body.classList.contains('lb-aperta') && lb.contains(e.target) && !scorso) chiudi();
  });

  document.addEventListener('keydown', function (e) {
    if (!document.body.classList.contains('lb-aperta')) return;
    if (e.key === 'Escape') chiudi();
    else if (e.key === 'ArrowRight') mostra(indice + 1);
    else if (e.key === 'ArrowLeft') mostra(indice - 1);
  });

  /* scorrimento col dito: e' il gesto che la gente prova per prima sul telefono */
  var x0 = null, y0 = null;
  lb.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches[0]) return;
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  lb.addEventListener('touchend', function (e) {
    if (x0 === null || !e.changedTouches || !e.changedTouches[0]) return;
    var dx = e.changedTouches[0].clientX - x0;
    var dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      scorso = true;
      setTimeout(function () { scorso = false; }, 400);
      mostra(indice + (dx < 0 ? 1 : -1));
    }
    x0 = null; y0 = null;
  }, { passive: true });
})();


/* =========================================================================
   BARRA FISSA DELLA HOME (03/09)
   La home e' lunga 5.800 px e aveva UN SOLO collegamento al prodotto, in cima.
   Chi scorreva fino in fondo trovava come unico pulsante "INVIA" del modulo
   contatti. Qui la barra compare superata la piega e resta sempre a portata di
   pollice; l'altezza sopra il banner cookie la gestisce il blocco precedente.
   ========================================================================= */
(function () {
  if (!document.querySelector('.hsticky')) return;
  /* lo spazio si riserva subito: se lo aggiungessimo insieme alla barra la
     pagina farebbe un salto di 84 px sotto il dito di chi sta scorrendo */
  document.body.classList.add('home-bar-space');
  var soglia = 500;
  var attesa = null;
  function guarda() {
    if (attesa) return;
    attesa = setTimeout(function () {
      attesa = null;
      var giu = (window.pageYOffset || document.documentElement.scrollTop || 0) > soglia;
      document.body.classList.toggle('home-bar', giu);
    }, 80);
  }
  window.addEventListener('scroll', guarda, { passive: true });
  window.addEventListener('resize', guarda);
  guarda();
})();


/* =========================================================================
   SEZIONE PACCHETTI DELLA HOME (sections/packs.liquid)
   05/09 - dalla registrazione Clarity delle 20:31: le due schede di prezzo
   ricevevano clic su clic senza fare niente (dead click) e il pulsante sotto
   era solo un rimando alla scheda prodotto.
   Qui le schede diventano un vero gruppo di scelta della quantita', sotto
   compaiono le righe del colore (una per pezzo, come nella scheda prodotto) e
   il pulsante aggiunge al carrello davvero, aprendo il pannello laterale.
   Se manca fetch/closest non si aggancia niente: resta il modulo con il menu a
   tendina del colore che fa il POST normale a /cart/add. Nessuna funzione persa.
   ========================================================================= */
(function () {
  if (!window.fetch || !Element.prototype.closest || !window.cbCartAdd) return;
  /* la sezione ha un preset: nel tema si puo' aggiungere piu' di una volta */
  [].forEach.call(document.querySelectorAll('[data-pk-form]'), collega);

  function collega(form) {
    var dati = form.parentNode.querySelector('[data-pk-vars]');
    var vars = [];
    if (dati) { try { vars = JSON.parse(dati.textContent) || []; } catch (e) { vars = []; } }
    if (!vars.length) return;

    var plain = form.querySelector('[data-pk-plain]');
    var campoQty = form.querySelector('[data-pk-qty]');
    var selVar = form.querySelector('#pkVariant');
    var boxMix = form.querySelector('[data-pk-mix]');
    var righe = form.querySelector('[data-pk-rows]');
    var nota = form.querySelector('[data-pk-note]');
    var errBox = form.querySelector('[data-pk-err]');
    var bottone = form.querySelector('[data-pk-add]');
    var schede = [].slice.call(form.querySelectorAll('[data-pk-q]'));
    if (!schede.length || !bottone) return;

    /* da qui in poi comanda il JavaScript: il ripiego con il menu a tendina
       sparisce, ma resta nel DOM perche' e' lui a portare "id" e "quantity" se
       qualcosa va storto e il modulo viene inviato davvero */
    if (plain) plain.hidden = true;

    var sel = [];   /* un id variante per ogni pezzo */

    function base() {
      var i;
      if (selVar) {
        for (i = 0; i < vars.length; i++) {
          if (String(vars[i].id) === String(selVar.value) && vars[i].a) return vars[i].id;
        }
      }
      for (i = 0; i < vars.length; i++) if (vars[i].a) return vars[i].id;
      return vars[0].id;
    }

    function perId(id) {
      for (var i = 0; i < vars.length; i++) if (String(vars[i].id) === String(id)) return vars[i];
      return null;
    }

    function quantita() {
      for (var i = 0; i < schede.length; i++) {
        if (schede[i].classList.contains('on')) return parseInt(schede[i].getAttribute('data-pk-q'), 10) || 1;
      }
      return 1;
    }

    function errore(testo) {
      if (!errBox) return;
      errBox.textContent = testo || '';
      errBox.hidden = !testo;
    }

    /* quante varianti sono davvero comprabili: con una sola non ha senso
       chiedere il colore pezzo per pezzo */
    function comprabili() {
      var n = 0;
      for (var i = 0; i < vars.length; i++) if (vars[i].a) n++;
      return n;
    }

    function riepilogo() {
      if (!nota) return;
      var ordine = [], mappa = {}, i;
      for (i = 0; i < sel.length; i++) {
        var k = String(sel[i]);
        if (!mappa[k]) { mappa[k] = 0; ordine.push(k); }
        mappa[k]++;
      }
      nota.textContent = cbT('mix_carrello', 'Nel carrello: @', ordine.map(function (k) {
        var v = perId(k);
        return mappa[k] + ' × ' + (v ? v.t : '');
      }).join(', '));
    }

    function disegna() {
      var q = quantita();
      var b = base(), i, j;

      if (campoQty) campoQty.value = q;

      while (sel.length < q) sel.push(b);
      if (sel.length > q) sel.length = q;
      for (i = 0; i < sel.length; i++) {
        var v = perId(sel[i]);
        if (!v || !v.a) sel[i] = b;
      }

      /* con un colore solo comprabile le righe non servono: si aggiunge quello */
      if (comprabili() < 2 || !righe) {
        if (boxMix) boxMix.hidden = true;
        return;
      }
      if (boxMix) boxMix.hidden = false;

      if (righe.childElementCount !== sel.length) {
        righe.innerHTML = '';
        for (i = 0; i < sel.length; i++) {
          var r = document.createElement('div');
          r.className = 'mix-row';
          var l = document.createElement('span');
          l.className = 'mix-lbl';
          /* con un pezzo solo "Pezzo 1" e' rumore: si mostra il nome dell'opzione */
          l.textContent = sel.length > 1
            ? cbT('mix_pezzo', 'Pezzo @', i + 1)
            : (form.getAttribute('data-pk-opt') || cbT('mix_pezzo', 'Pezzo @', 1));
          r.appendChild(l);
          var g = document.createElement('div');
          g.className = 'mix-sw';
          for (j = 0; j < vars.length; j++) {
            var vv = vars[j];
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'mix-b' + (vv.a ? '' : ' mix-off');
            btn.setAttribute('data-pk-v', vv.id);
            btn.setAttribute('data-pk-i', i);
            btn.textContent = vv.a ? vv.t : vv.t + ' — ' + cbT('esaurito_min', 'esaurito');
            if (!vv.a) btn.disabled = true;
            g.appendChild(btn);
          }
          r.appendChild(g);
          righe.appendChild(r);
        }
      }

      Array.prototype.forEach.call(righe.querySelectorAll('.mix-b'), function (btn) {
        var i = parseInt(btn.getAttribute('data-pk-i'), 10);
        var on = String(sel[i]) === btn.getAttribute('data-pk-v');
        btn.classList.toggle('on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      riepilogo();
    }

    /* --- scelta del pacchetto e del colore --- */
    form.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var scheda = e.target.closest('[data-pk-q]');
      if (scheda && form.contains(scheda)) {
        schede.forEach(function (s) {
          var on = s === scheda;
          s.classList.toggle('on', on);
          s.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        errore('');
        disegna();
        return;
      }

      var sw = e.target.closest('[data-pk-v]');
      if (sw && form.contains(sw) && !sw.disabled) {
        var i = parseInt(sw.getAttribute('data-pk-i'), 10);
        var v = perId(sw.getAttribute('data-pk-v'));
        if (!v || !v.a) return;
        sel[i] = v.id;
        errore('');
        disegna();
      }
    });

    /* --- tastiera: le schede sono un radiogroup, le frecce devono spostarsi --- */
    form.addEventListener('keydown', function (e) {
      var scheda = e.target.closest ? e.target.closest('[data-pk-q]') : null;
      if (!scheda) return;
      var d = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') d = 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') d = -1;
      if (!d) return;
      e.preventDefault();
      var i = schede.indexOf(scheda);
      var n = schede[(i + d + schede.length) % schede.length];
      n.focus();
      n.click();
    });

    /* --- aggiunta al carrello --- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errore('');

      /* si raggruppano i pezzi uguali: due volte lo stesso colore deve diventare
         UNA riga da 2 nel carrello, non due righe da 1 */
      var mappa = {}, ordine = [], i;
      for (i = 0; i < sel.length; i++) {
        var k = String(sel[i]);
        if (!mappa[k]) { mappa[k] = 0; ordine.push(k); }
        mappa[k]++;
      }
      if (!ordine.length) return;

      /* giacenza: se di un colore non ce ne sono abbastanza si avvisa prima di
         chiamare il server, che risponderebbe con un errore in inglese */
      for (i = 0; i < ordine.length; i++) {
        var v = perId(ordine[i]);
        var max = (v && typeof v.m === 'number') ? v.m : 99;
        if (mappa[ordine[i]] > max) {
          errore(cbT('mix_max', 'Di @ non ci sono abbastanza pezzi disponibili.', v ? v.t : ''));
          return;
        }
      }

      var testo = bottone.innerHTML;
      bottone.disabled = true;
      bottone.textContent = cbT('aggiungo', 'Aggiungo…');

      function ripristina(msg) {
        bottone.disabled = false;
        bottone.innerHTML = testo;
        if (msg) errore(msg);
      }

      var partito = window.cbCartAdd(
        ordine.map(function (k) { return { id: parseInt(k, 10), quantity: mappa[k] }; }),
        bottone,
        ripristina
      );
      /* false = c'e' gia' una chiamata al carrello in corso, il clic si ignora */
      if (partito === false) { ripristina(); return; }

      /* cbCartAdd non ha un "finito" da agganciare: senza questo il pulsante
         resterebbe su "Aggiungo..." e la sezione sembrerebbe morta al secondo giro */
      setTimeout(function () { ripristina(); }, 1500);
    });

    disegna();
  }
})();


/* =========================================================================
   STRISCIA "OFFERTA A TEMPO LIMITATO" (scheda prodotto)
   Una riga sottile sopra il prezzo: testo, contatore mm:ss e una barra che
   si accorcia. Arrivata a zero riparte da capo.
   La striscia nasce con hidden nel Liquid e la scopre questo blocco: senza
   JavaScript un contatore fermo su 05:00 sarebbe peggio del non averlo.
   Il tempo si calcola sempre da un orario di fine, mai sommando i tick: nelle
   schede in secondo piano il browser rallenta setInterval e un contatore
   incrementale resterebbe indietro di minuti.
   ========================================================================= */
(function () {
  var box = document.querySelector('[data-timer]');
  if (!box) return;

  var testoC = box.querySelector('[data-timer-c]');
  var barra = box.querySelector('[data-timer-bar]');
  var totale = (parseInt(box.getAttribute('data-timer-sec'), 10) || 300) * 1000;
  if (totale < 1000) totale = 300000;

  var fine = Date.now() + totale;
  box.hidden = false;

  function due(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var resta = fine - Date.now();
    if (resta <= 0) {
      /* si riparte dal giro pieno, senza accumulare il ritardo del tick */
      fine = Date.now() + totale;
      resta = totale;
    }
    var sec = Math.ceil(resta / 1000);
    if (testoC) testoC.textContent = due(Math.floor(sec / 60)) + ':' + due(sec % 60);
    if (barra) barra.style.width = (resta / totale * 100).toFixed(2) + '%';
  }

  tick();
  setInterval(tick, 250);
})();

/* =========================================================================
   GALLERIA CHE SI SFOGLIA
   08/09. Le foto si cambiavano solo toccando le miniature: sul telefono il
   gesto naturale e' scorrere col dito sulla foto grande, e non succedeva
   niente. Ora si scorre a destra e a sinistra, sotto ci sono i puntini e su
   computer compaiono due frecce. Le miniature restano dove sono e continuano
   a funzionare: questo codice si limita a chiamare le stesse funzioni.
   Con una sola foto non compare nulla.
   ========================================================================= */
(function () {
  var gal = document.querySelector('.gal');
  if (!gal) return;
  var main = document.getElementById('cbMain');
  var cornice = gal.querySelector('.main');
  var striscia = gal.querySelector('.thumbs');
  var punti = gal.querySelector('[data-gal-dots]');
  var mini = [].slice.call(gal.querySelectorAll('.thumbs img'));
  if (!main || !cornice || mini.length < 2) return;

  var frecce = [].slice.call(cornice.querySelectorAll('[data-gal-passo]'));
  frecce.forEach(function (f) { f.hidden = false; });

  function attuale() {
    for (var i = 0; i < mini.length; i++) {
      if (mini[i].classList.contains('on')) return i;
    }
    return 0;
  }

  /* la miniatura scelta deve restare visibile nella striscia, altrimenti
     scorrendo col dito si perde il riferimento di dove si e' arrivati */
  function seguiStriscia(t) {
    if (!striscia || striscia.scrollWidth <= striscia.clientWidth) return;
    var meta = t.offsetLeft - (striscia.clientWidth - t.offsetWidth) / 2;
    if (meta < 0) meta = 0;
    try { striscia.scrollTo({ left: meta, behavior: 'smooth' }); }
    catch (e) { striscia.scrollLeft = meta; }
  }

  function vaiA(i) {
    i = (i + mini.length) % mini.length;
    var t = mini[i];
    if (!t || t.classList.contains('on')) return;
    cbPick(t, t.getAttribute('data-src') || t.src);
    seguiStriscia(t);
  }

  if (punti) {
    mini.forEach(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gal-dot';
      b.setAttribute('aria-label', (i + 1) + ' / ' + mini.length);
      b.addEventListener('click', function () { vaiA(i); });
      punti.appendChild(b);
    });
  }

  function sincronizza() {
    if (!punti) return;
    var i = attuale();
    [].slice.call(punti.children).forEach(function (d, n) {
      if (n === i) { d.classList.add('on'); d.setAttribute('aria-current', 'true'); }
      else { d.classList.remove('on'); d.removeAttribute('aria-current'); }
    });
  }
  window.cbGalSync = sincronizza;
  sincronizza();

  /* --- scorrimento col dito --- */
  var x0 = null, y0 = null, scorso = false;
  cornice.addEventListener('touchstart', function (e) {
    if (!e.touches || !e.touches[0]) return;
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, { passive: true });
  cornice.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var t = e.changedTouches && e.changedTouches[0];
    var dx = t ? t.clientX - x0 : 0;
    var dy = t ? t.clientY - y0 : 0;
    x0 = null; y0 = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
    /* subito dopo uno scorrimento arriva un click: senza questo si aprirebbe
       l'ingrandimento a schermo intero a ogni sfogliata */
    scorso = true;
    setTimeout(function () { scorso = false; }, 400);
    vaiA(attuale() + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* in cattura: arriva prima del gestore che apre l'ingrandimento */
  cornice.addEventListener('click', function (e) {
    if (scorso) { e.preventDefault(); e.stopPropagation(); return; }
    if (!e.target.closest) return;
    var p = e.target.closest('[data-gal-passo]');
    if (!p) return;
    e.preventDefault();
    e.stopPropagation();
    vaiA(attuale() + (parseInt(p.getAttribute('data-gal-passo'), 10) || 0));
  }, true);
})();
